<template>
  <div>
    <OtpDefault @get-otp="getDataPayment" @send-otp="confirm_otp_for_wap" />
  </div>
</template>
<script>
import GlobalAPI from "@/views/api/wap/global";
import { getInfoBooked } from "@/utils/booked";
import OtpDefault from "@/views/pages/wapV2/otp/OtpDefault.vue";
export default {
  name: "PaymentEpay",
  computed: {},
  components: {
    OtpDefault
  },
  props: {},

  data() {
    return {
      transaction_id: null,
      loadingData: false
    };
  },
  created() {
    this.getDataPayment();
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    getDataPayment() {
      console.log("vafp fsau");
      const body = {
        type: "point",
        money: getInfoBooked()?.payment_amount,
        data_provider: {
          transaction_id: getInfoBooked().transaction_id,
          general_bill_id: getInfoBooked().id_general_bill
        },
        provider: "general_bill"
      };
      this.loadingData = true;
      GlobalAPI.create_request_for_wap(body)
        .then(res => {
          const { error_code, data, error_msg } = res;
          if (error_code !== 0) {
            this.$message.error(error_msg);
            return;
          } else {
            this.transaction_id = data.transaction_id;
            console.log("error_code____________________", res);
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
    confirm_otp_for_wap(code) {
      const body = {
        transaction_id: this.transaction_id,
        code
      };
      GlobalAPI.confirm_otp_for_wap(body).then(res => {
        // console.log("res_____________", res);
        const { error_code, data, error_msg } = res;
        if (error_code !== 0) {
          this.$message.error(error_msg);
          return;
        } else {
          this.$router.push("/wap/history?type=2");
        }
      });
    }
  }
};
</script>

<style scoped>
.top-spacing {
  padding-top: 75px;
}
.el-title-buy-insurance {
  display: flex;
  justify-content: center;
  flex-direction: row;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  align-items: center;
}

.logo-wghn {
  display: block;
  width: 100%;
  height: 225px;
  object-fit: cover;
}

.el-item-in-background {
  /* padding-bottom: 20px; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.center-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

.center-container > * {
  max-width: 90%;
}

.el-user {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}

.right-align {
  text-align: right;
}

.el-row-info-user-buy {
  padding: 10px;
}

.button-wrapper {
  margin-top: auto;
}

.el-icon-back {
  padding-left: 11px;
  font-size: 20px;
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .top-spacing {
    padding-top: 55px;
  }
}
</style>
